import React, { useContext, useEffect, useState } from "react";
import {
  MsgError,
  MsgLoading,
  MsgSuccess,
} from "../../../components/Loaders/MessageLoaders";
import TextEditor from "../../../components/QuillEditor/TextEditior";
import TravelGuideService from "../../../services/TraverGuideService";
import LangContext from "../../../context/LanguageContext";

export type TravelGuideInputs = {
  id?: string;
  travel_guide_title: string;
  travel_guide_description: string;
};
const TabAddTravelGuide = ({ editItemId }: { editItemId?: string }) => {
  const [isTranslationActive, setIsTranslationActive] = useState(false);
  const [description, setDescription] = useState<string>("");
  const [title, setTitle] = useState<string>("");
  const [errors, setErrors] = useState<
    {
      location: string;
      msg: string;
      param: string;
    }[]
  >([]);

  const { lang_id, lang } = useContext(LangContext);

  const storeTravelGuide = async () => {
    try {
      MsgLoading();
      const data = {
        travel_guide_title: title,
        travel_guide_description: description,
        lang: lang_id,
      };

      if (editItemId) {
        const res = await TravelGuideService.updateTravelGuide(
          editItemId,
          data
        );
        MsgSuccess(res.data.message);
      } else {
        const res = await TravelGuideService.storeTravelGuide(data);
        MsgSuccess(res.data.message);
      }
    } catch (error: any) {
      if (error.response) {
        MsgError(error.response.data.message || "Error while uploading....");
        if (error.response.data.errors) {
          setErrors(error.response.data.errors);
        }
      }
      console.log(error);
    }
  };

  const fetchTravelGuideDetails = async (id: string) => {
    try {
      const res = await TravelGuideService.getTravelGuideDetail(id);
      setTitle(res.data.data.travel_guide_title);
      setDescription(res.data.data.travel_guide_description);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (editItemId) {
      fetchTravelGuideDetails(editItemId);
    }
  }, [editItemId]);

  return (
    <div>
      {/* {isTranslationActive ? <p className='text-gray-600 mt-8'>Click to add travel guide with <span className='text-primary-base underline cursor-pointer' onClick={() => setIsTranslationActive(false)}> base language. </span></p> :
                <p className='text-gray-600 mt-8'>To add translation click <span className='text-primary-base underline cursor-pointer' onClick={() => setIsTranslationActive(true)}> translated travel guide.</span></p>} */}

      <div className="my-4">
        <form
          action="w-fit my-10"
          onSubmit={(e) => {
            e.preventDefault();
            storeTravelGuide();
          }}
        >
          <div className="flex flex-col space-y-3 my-4">
            <label htmlFor="title">Travel guide title ({lang})</label>
            <input
              type="text"
              id="title"
              className="form-input inputs"
              required
              value={title}
              placeholder="Enter a travel guide heading...."
              onChange={(e) => setTitle(e.target.value)}
            />
            {errors.length > 0 && (
              <span className="text-red-500 text-sm">{errors[0].msg}</span>
            )}
          </div>

          <div className="flex flex-col space-y-2 my-3">
            <label htmlFor="">Important Info ({lang})</label>
            <TextEditor
              value={description}
              onChange={setDescription}
              placeholder="Write important info article here....."
            />
            {errors.length > 0 && (
              <span className="text-red-500 text-sm">{errors[0].msg}</span>
            )}

            {/* <ReactQuill theme="snow" value={description} onChange={setDescription} /> */}
          </div>

          <div className="flex flex-col space-y-3 my-4">
            <input type="submit" className="btn btn-primary" value="Submit" />
          </div>
        </form>
      </div>
    </div>
  );
};

export default TabAddTravelGuide;
